import { render } from "./domain-history-by-keys.vue?vue&type=template&id=006c6fb0"
import script from "./domain-history-by-keys.vue?vue&type=script&lang=js"
export * from "./domain-history-by-keys.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__